module.exports = __webpack_public_path__ + "../../dist/v1/img/icon_youtube.svg";